var React = require('react');

function Moon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M8.06567 6.02551C6.21318 7.28662 5 9.4115 5 11.8166C5 15.6826 8.13401 18.8166 12 18.8166C14.4051 18.8166 16.5299 17.6034 17.7911 15.7509C12.6817 15.1924 8.62421 11.1348 8.06567 6.02551ZM19 13.8166C19.866 13.8166 20.6118 14.5798 20.2691 15.3752C18.8898 18.5759 15.7066 20.8166 12 20.8166C7.02944 20.8166 3 16.7871 3 11.8166C3 8.11 5.24067 4.92676 8.4414 3.54749C9.23674 3.20475 10 3.95054 10 4.81658C10 9.78715 14.0294 13.8166 19 13.8166Z","fill":"black"}));
}

Moon.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Moon;

Moon.default = Moon;
